export type SafeStorage = {
  getItem(key: string): string | null;
  setItem(key: string, value: string): boolean;
  removeItem(key: string): boolean;
  clear(): boolean;
};

function storageAvailable(kind: 'localStorage' | 'sessionStorage'): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    const s = window[kind];
    // Accessing the property itself can throw in some environments.
    if (!s) return null;
    return s;
  } catch {
    return null;
  }
}

function makeSafe(kind: 'localStorage' | 'sessionStorage'): SafeStorage {
  return {
    getItem(key: string) {
      const s = storageAvailable(kind);
      if (!s) return null;
      try {
        return s.getItem(key);
      } catch {
        return null;
      }
    },
    setItem(key: string, value: string) {
      const s = storageAvailable(kind);
      if (!s) return false;
      try {
        s.setItem(key, value);
        return true;
      } catch {
        return false;
      }
    },
    removeItem(key: string) {
      const s = storageAvailable(kind);
      if (!s) return false;
      try {
        s.removeItem(key);
        return true;
      } catch {
        return false;
      }
    },
    clear() {
      const s = storageAvailable(kind);
      if (!s) return false;
      try {
        s.clear();
        return true;
      } catch {
        return false;
      }
    },
  };
}

export const safeLocalStorage = makeSafe('localStorage');
export const safeSessionStorage = makeSafe('sessionStorage');
